import { Schedule, StarRate } from '@mui/icons-material'
import { Button, Box } from '@mui/material'
import { useNotification } from '@refinedev/core'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import type { Scout } from '../../../scouts'
import { useRescheduleAppointmentMutation } from '../../api'
import type { Appointment } from '../../types.ts'

import RateScoutDialog from './RateScoutDialog'
import RescheduleDialog from './RescheduleDialog'

interface Props {
  appointment: Appointment
}

export const ClosedAppointmentActions = ({ appointment }: Props) => {
  const [rateScoutDialogOpen, setRateScoutDialogOpen] = React.useState(false)
  const [rescheduleDialogOpen, setRescheduleDialogOpen] = useState(false)
  const { open } = useNotification()

  const navigate = useNavigate()

  const { mutate: rescheduleAppointment, isPending: isRescheduling } =
    useRescheduleAppointmentMutation()

  const handleReschedule = (scout: Scout, dateTime: string, type: 'isfp' | 'marketplace') => {
    if (!appointment.uuid) return

    rescheduleAppointment(
      {
        appointmentId: appointment.uuid,
        scoutUUID: scout.uuid,
        scheduleStartTime: dateTime,
        type,
      },
      {
        onSuccess: result => {
          open?.({
            type: 'success',
            message: 'New appointment created successfully',
          })
          navigate(`/osa-scheduling/show/${result.data.uuid}`)
        },
        onError: error => {
          console.error('Error rescheduling appointment:', error)
          open?.({
            type: 'error',
            message: 'Failed to reschedule appointment',
            description: error.message,
          })
        },
      }
    )
  }

  return (
    <Box display="flex" gap={1} flexWrap="wrap">
      <Button
        variant="contained"
        startIcon={<Schedule />}
        onClick={() => setRescheduleDialogOpen(true)}
        size="small"
      >
        Reschedule
      </Button>

      {appointment.status === 'completed' && appointment.scoutUUID && (
        <Button
          variant="outlined"
          color="primary"
          startIcon={<StarRate />}
          onClick={() => setRateScoutDialogOpen(true)}
          size="small"
        >
          Rate Data
        </Button>
      )}

      {appointment?.uuid && appointment.scoutUUID && (
        <RateScoutDialog
          open={rateScoutDialogOpen}
          onClose={() => setRateScoutDialogOpen(false)}
          appointmentId={appointment.uuid}
          scoutUUID={appointment.scoutUUID}
          scoutName={appointment.scoutName}
        />
      )}

      <RescheduleDialog
        open={rescheduleDialogOpen}
        onClose={() => setRescheduleDialogOpen(false)}
        onConfirm={handleReschedule}
        customerName={appointment?.customerName}
        submitting={isRescheduling}
      />
    </Box>
  )
}
